export type ApiVersion = '1.0' | '2.0';

export interface AuthToken {
  token: string;
  expiresAt: number;
}

export interface TokenPayload {
  exp: number;
  [key: string]: any;
}

export class AuthError extends Error {
  constructor(message: string = 'Authentication failed') {
    super(message);
    this.name = 'AuthError';
  }
}

export class InvalidSystemError extends Error {
  constructor(message: string = 'System does not exist or does not have this feature enabled') {
    super(message);
    this.name = 'InvalidSystemError';
  }
}

export class HttpError extends Error {
  public statusCode: number;
  public data: any;

  constructor(statusCode: number, data: any = null) {
    super(`HTTP Error: Status code: ${statusCode}`);
    this.name = 'HttpError';
    this.statusCode = statusCode;
    this.data = data;
  }
}

export class TokenExpiredError extends AuthError {
  constructor() {
    super('Token has expired');
    this.name = 'TokenExpiredError';
  }
}
